<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Typography</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="typography-main-section col-12 float-l">
                    <div class="row">

                        <div class="typography-desire-main col-12 float-l">
                            <div class="row">

                                <div class="typography-desire-left col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"> <!--left side-->
                                    <div class="row">
                                        <div class="typography-inner width-full float-l bg-color-ffffff">
                                            <h3 class="heading-text-24 line-height-28 color-23727b font-text-regular-san width-full float-l"> Typography </h3>
                                            <p class="heading-text-14 line-height-16 color-7a7a7a font-text-regular-san width-full float-l mb-30"> Use tags h1 to h6 for get desire heading. </p>

                                            <h1 class="float-l width-full">h1. heading</h1>
                                            <h2 class="float-l width-full">h2. Sub heading</h2>
                                            <h3 class="float-l width-full">h3. Sub heading</h3>
                                            <h4 class="float-l width-full">h4. Sub heading</h4>
                                            <h5 class="float-l width-full">h5. Sub heading</h5>
                                            <h6 class="float-l width-full">h6. Sub heading</h6>
                                        </div>
                                    </div>
                                </div> <!--left side-->

                                <div class="typography-desire-right col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"> <!--right side-->
                                    <div class="row">
                                        <div class="typography-inner width-full float-l bg-color-ffffff">
                                            <h3 class="heading-text-24 line-height-28 color-23727b font-text-regular-san width-full float-l"> Text colors </h3>
                                            <h5 class="heading-text-14 line-height-16 color-7a7a7a font-text-regular-san width-full float-l mb-40"> Use tags below class for get desire text. </h5>

                                            <h5 class="color-9cadb5 float-l width-full font-text-regular-san pb-10">This is an example of muted text.  <span class="color-444444"> Add class text-muted </span> </h5>

                                            <h5 class="color-098de1 float-l width-full font-text-regular-san pb-10">This is an example of primary text.  <span class="color-444444"> Add class text-primary </span> </h5>

                                            <h5 class="color-71aa3f float-l width-full font-text-regular-san pb-10">This is an example of success text. <span class="color-444444"> Add class text-success </span> </h5>

                                            <h5 class="color-098de1 float-l width-full font-text-regular-san pb-10">This is an example of info text. <span class="color-444444"> Add class text-info </span> </h5>

                                            <h5 class="color-ffbb44 float-l width-full font-text-regular-san pb-10">This is an example of warning text. <span class="color-444444"> Add class text-warning </span> </h5>

                                            <h5 class="color-c3202b float-l width-full font-text-regular-san">This is an example of danger text.  <span class="color-444444"> Add class text-danger </span> </h5>
                                        </div>
                                    </div>
                                </div> <!--right side-->
                                .
                                <div class="typography-text-para col-12 float-l mt-40"> <!--middle section-->
                                    <div class="row">

                                        <div class="typography-address col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 width-full"> <!--address-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Address </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"> Use address for get desire address </h6>
                                                <p> Velocity Vehicle Group <br/>
                                                    795 Folsom Ave, Suite 600  <br/>
                                                    San Francisco, CA 94107 </p>

                                                <div class="btm-contact-detail width-full float-l mt-10">
                                                    <p class="heading-text-17 line-height-21 color-444444 font-text-regular-san"> <span> <i class="hi-icon icon-abmcontact"> </i> </span> P:(123) 456-7890 </p>

                                                    <p class="heading-text-17 line-height-21 color-444444 font-text-regular-san" href="#"> <span> <i class="hi-icon icon-abmenvelope"> </i> </span> <a class="color-444444" href="mailto:first.last@example.com"> first.last@example.com </a> </p>
                                                </div>

                                            </div>
                                        </div> <!--address-->

                                        <div class="para-justify col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 width-full"> <!--para justify-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Paragraph with justify </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"> Use tags text-justify for get desire paragraph. </h6>

                                                <div class="btm-contact-detail width-full float-l mt-10">
                                                    <p class="heading-text-17 line-height-21 color-444444 font-text-regular-san text-justify"> Ambitioni dedisse scripsisse iudicaretur. Cras mattis iudicium purus sit amet fermentum. Donec sed odio operae, eu vulputate felis rhoncus. Praeterea iter est quasdam res quas ex communi. At nos hinc posthac, sitientis piros Afros. Petierunt uti sibi concilium totius Galliae in diem certam indicere. Cras mattis iudicium purus sit amet fermentum.</p>

                                                </div>

                                            </div>
                                        </div> <!--para justify-->

                                        <div class="blockquotes-manual col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 width-full"> <!--blockquotes-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Blockquotes </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"> Use blockquote for get desire address. </h6>

                                                <div class="blockquote-aum width-full float-l mt-10">
                                                    <blockquote class="blockquote-aum-para float-l colpie-76">
                                                        <p class="mb-0 color-444444 heading-text-17 line-height-26 font-text-regular-san width-full float-l">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
                                                    </blockquote>
                                                </div>

                                                <div class="blockquote-aum width-full float-l">
                                                    <blockquote class="blockquote-aum-para float-l colpie-76">
                                                        <p class="mb-0 color-444444 heading-text-17 line-height-26 font-text-regular-san width-full float-l">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>

                                                        <p class="blockquote-footer mb-0 mt-20 color-c3202b heading-text-15 line-height-26 font-text-medium-san width-full float-l">Someone famous in Source Title</p>
                                                    </blockquote>
                                                </div>

                                            </div>
                                        </div> <!--blockquotes-->

                                    </div>
                                </div> <!--middle section-->

                                <div class="typography-listing-main col-12 float-l mt-40"> <!--bottom section-->
                                    <div class="row">

                                        <div class="listing-detail-normal float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> <!--normal-listing-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Ul Listing </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"> Use tags ul > li for get desire ol list. </h6>

                                                <div class="listing-detail-aum-normal float-l width-full">
                                                    <ul class="pl-15">
                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div> <!--normal-listing-->

                                        <div class="listing-detail-fancy float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> <!--fancy-listing-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Fancy Listing 1 </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"> Use tags ul > li for get desire ol list.  </h6>

                                                <div class="listing-detail-aum-fancy float-l width-full">
                                                    <ul class="pl-15">
                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8">Lorem ipsum dolor sit amet</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div> <!--fancy-listing-->

                                        <div class="listing-detail-href float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> <!--href-listing-->
                                            <div class="row">
                                                <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-2"> Fancy Listing with href </h3>
                                                <h6 class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15">Use class list-iconsto ul for get desire ol list. </h6>

                                                <div class="listing-detail-aum-href float-l width-full">
                                                    <ul class="pl-15">
                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"> <a class="color-444444" href="#"> Lorem ipsum dolor sit amet </a> </li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"> <a class="color-444444" href="#"> Lorem ipsum dolor sit amet </a> </li>

                                                        <li class="color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"> <a class="color-444444" href="#"> Lorem ipsum dolor sit amet </a> </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div> <!--href-listing-->

                                    </div>
                                </div> <!--bottom section-->

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Tooltip } from 'bootstrap-vue/es/components';
    import { Popover } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {

            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/typography.vue